<template>
  <component :is="'div'" name="termly-embed" data-id="97db19c6-7afc-444b-bd38-9a2ac329fcac" data-type="iframe" />
</template>
